/* global  moment, _ */
import './style.less';

export default function($log, $scope) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  vm.showInactive = false;

  vm.selectAll = false;
  vm.filteredUsers = [];
  vm.rawUsers = [];

  let watchModel = true;

  vm.onFilter = function(stCtrl) {
    vm.filteredUsers = stCtrl.getFilteredCollection();
  };

  vm.updateSelected = function() {
    vm.selectedUsers = vm.rawUsers.filter(({ selected }) => selected);
    vm.selectedCount = vm.selectedUsers.length;
  };

  vm.onClickSelectAll = function(selectAll) {
    vm.filteredUsers.forEach(user => (user.selected = selectAll));
    vm.updateSelected();
  };

  vm.activeInactiveChange = value => {
    if (!vm.ngModel) return;
    watchModel = false;
    if (value && value.model) return (vm.rawUsers = [...vm.ngModel]);
    vm.rawUsers = vm.rawUsers.filter(({ archived }) => !archived);
  };

  vm.deactivateAccount = user => {
    vm.deactivate({ user })
      .then(profile => {
        user = profile;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.activateAccount = user => {
    vm.activate({ user })
      .then(profile => {
        user = profile;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.removeAccountInvite = user => {
    vm.remove({ user })
      .then(() => {
        vm.activeInactiveChange({ model: vm.showInactive });
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.submit = () => {
    vm.submitBtn = true;

    const users = vm.ngModel.filter(user => user.selected);

    vm.action({ users })
      .then(() => {
        vm.ngModel.forEach(user => (user.selected = false));
        vm.onClickSelectAll(false);
        vm.submitBtn = false;
      })
      .catch(error => {
        vm.submitBtn = false;
        $log.error(error);
        throw error;
      });
  };

  // Watch for data load then update tables
  $scope.$watch(() => (watchModel ? vm.ngModel : undefined), () => vm.activeInactiveChange({ model: vm.showInactive }));

  function activate() {
    $log.debug('Users Basic Table Component Activated');
    vm.selectedCount = 0;
    vm.selectAll = false;
    vm.showInactive = false;
    vm.rawUsers.length = 0;
    vm.rawUsers.push(...(vm.ngModel || []));
    vm.activeInactiveChange();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tables/usersBasic/controller.js